import create from "zustand";

interface QuotationState {
  quotationDetail: any;
  loadingDetail: boolean;
  quotation_id: any | null;
  fetchquotationDetail: (id: any) => void;
  setQuotationId: (id: any) => void;
}

const usequotation = create<QuotationState>((set) => ({
  quotationDetail: null,
  loadingDetail: false,
  quotation_id: null,

  fetchquotationDetail: async (id) => {
    set({ loadingDetail: true });
    // Fetch logic here
    set({ loadingDetail: false });
  },

  setQuotationId: (id) => set({ quotation_id: id }),
}));

export default usequotation;
